/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Directive, ViewContainerRef } from '@angular/core';

/**
 * This is a placeholder directive for dynamically instantiating and inserting a custom content component into a
 * DialogComponent.
 */
@Directive({
  selector: '[aeroDialogContentPlaceholder]',
  standalone: false,
})
export class DialogContentPlaceholderDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
